import BankBrachList from './bank-brach-list';

export default BankBrachList;
